import React from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';

import { useModal } from '../Components/Modal/ModalContext';
import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import HeaderPanel from '../Components/HeaderPanel';
import CardOfAM from '../Components/CardOfAM';
import AddNewEmailAMModal from '../Components/AddNewEmailAMModal';
import ChangeEmailAMModal from '../Components/ChangeEmailAMModal';
import AddNewRegionModal from '../Components/AddNewRegionModal';
import ChangeRegionModal from '../Components/ChangeRegionModal';

import styles from '../styles/TableContainers.module.css';

const EmailsAM = () => {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();
    const [regions, setRegions] = React.useState([]);
    const [warning, setWarning] = React.useState('Загрузка...');
    const [visibilityButton, setVisibilityButton] = React.useState(false);
    const [reload, setReload] = React.useState(true);

    const [isCardOfAM, setIsCardOfAM] = React.useState(false);
    const [isAddNewEmailAM, setIsAddNewEmailAM] = React.useState(false);
    const [isChangeEmailAM, setIsChangeEmailAM] = React.useState(false);
    const [isChangeRegion, setIsChangeRegion] = React.useState(false);
    const [isNewRegionModal, setIsNewRegionModal] = React.useState(false);
    const [currentAMId, setCurrentAMId] = React.useState('');
    const [currentEmailId, setCurrentEmailId] = React.useState('');
    const [currentRegionId, setCurrentRegionId] = React.useState('');

    React.useEffect(() => {
        const bannerShown = Cookies.get('bannerTDltEmailsAM');        
        const bannerEmailsAMAboutDelete = 
        <form>
            <h3 style={{marginBottom: '15px'}}>Следующая страница содержит список email-адресов арбитражных управляющих.</h3>
            <a>Эти адреса используются системой для отправки заявок на ведение дел.</a>
            <a>Данный список хранится в отдельной таблице, не связанной с таблицей пользователей.</a>
            <a>При удалении или изменении email-адреса в этом окне изменения затронут только этот список, и связь с учётной записью будет утрачена.</a>
        </form>;
        if (!bannerShown) {
            // Если баннер еще не был показан, показываем его
            openModal('Ознакомление с системой', bannerEmailsAMAboutDelete);
            
            // Устанавливаем куки, чтобы отметить, что баннер был показан
            Cookies.set('bannerTDltEmailsAM', 'true', { expires: 365 }); // Куки будет храниться 1 год
        }

        axios.get('/api/emails-am')
            .then(response => {
                if (response.data.length === 0) {
                    setWarning('В системе нет ни одного арбитражного управляющего и региона.');
                    setVisibilityButton(true);
                } else {
                    setRegions(response.data);
                    setWarning('');
                }
                setReload(false);
            })
            .catch(error => {
                console.error('Ошибка при получении данных:', error);
                setWarning('Не удалось загрузить список: ' + error.message);
                setReload(false);
            });
    }, [reload]);

    const deleteEmailAM = (id) => {
        axios.delete(`/api/email-am?id=${id}`)
        .then(() => {
            setConfirmDeleteEmailAM('');
            setReload(true);
            openTimeModal(`Email успешно удалён из системы`, 'success');
        })
        .catch(error => {
            setConfirmDeleteEmailAM('');
            console.error('Ошибка при удалении e-mail адреса:', error);
            openTimeModal(`Не удалось удалить email из таблицы. ${error.response?.data.message || error.message}`, 'error');
        })
    }

    const [confirmDeleteEmailAM, setConfirmDeleteEmailAM] = React.useState(null);
    const [confirmDeleteRegion, setConfirmDeleteRegion] = React.useState(null);
    const handleDeleteClickEmailAM = (id) => {
        if (confirmDeleteEmailAM === id) {
            deleteEmailAM(id);
        } else {
            setConfirmDeleteEmailAM(id);
        }
    }

    const closeSModal = () => {
        setIsCardOfAM(false)
        setIsAddNewEmailAM(false);
        setIsChangeEmailAM(false);
        setIsNewRegionModal(false);
        setIsChangeRegion(false);
    }

    const deleteRegion = (regionId) => {
        axios.delete(`/api/region?id=${regionId}`)
        .then(() => {
            setRegions(regions.filter(region => region.id !== regionId));
            setConfirmDeleteRegion(null);
            openTimeModal(`Регион успешно удалён из системы`, 'success');
        })
        .catch(error => {
            setConfirmDeleteRegion('');
            openTimeModal(`Не удалось удалить регион из системы. ${error.response?.data.message || error.message}`, 'error');
        });
    };

    const handleDeleteClickRegion = (regionId) => {
        if (confirmDeleteRegion === regionId) {
            deleteRegion(regionId);
        } else {
            setConfirmDeleteRegion(regionId);
        }
    };

    const warningModal = 
    <form style={{textAlign: 'center'}}>
        <h3>Внимание,</h3>
        <a style={{cursor: 'text', fontSize: '16px'}}>Если вы хотите удалить email-адрес арбитражного управляющего из системы сначала снимите доступ и деактивируйте учётную запись этого арбитражного управляющего на вкладке "Выдача доступа к системе" в настройках.</a>
    </form>;
    

    return (
    <>
        {isCardOfAM && <CardOfAM closeModal={closeSModal} id={currentAMId} />}
        {isAddNewEmailAM && <AddNewEmailAMModal closeModal={closeSModal} regionId={currentRegionId} onReloadTable={() => {setReload(true)}} />}
        {isChangeEmailAM && <ChangeEmailAMModal closeModal={closeSModal} id={currentEmailId} onReloadTable={() => {setReload(true)}} />}
        {isNewRegionModal && <AddNewRegionModal closeModal={closeSModal} onReloadTable={() => {setReload(true)}} />}
        {isChangeRegion && <ChangeRegionModal closeModal={closeSModal} id={currentRegionId} onReloadTable={() => {setReload(true)}} />}
        <div className='mainContainer'>
            <h1>Арбитражные управляющие и регионы</h1>
            <HeaderPanel typePanel='Назад' />
            
            {warning ? 
            (
                <>
                {visibilityButton && (
                    <button type="button" className="button" style={{ margin: '10px 0 0 0', width: 'fit-content' }} onClick={() => {setIsNewRegionModal(true);}}>
                        <svg viewBox="0 0 24 24" id="plus" fill="currentColor"><path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path></svg>
                        Добавить новый регион
                    </button>)
                }
                <div className='case warningLine' style={{ margin: '12px 0'}}><a>{warning}</a></div>
                </>
            )
            :
            (
            <>
                <button type="button" className="button" style={{ margin: '10px 0 0 0', width: 'fit-content' }} onClick={() => {setIsNewRegionModal(true);}}>
                    <svg viewBox="0 0 24 24" id="plus" fill="currentColor"><path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path></svg>
                    Добавить новый регион
                </button>

                {regions.map(region => (
                <>
                    <div className={styles.tableDescription} key={region.id}>
                        <h2>{region.name}</h2>
                        <span>
                            <svg onClick={() => {setIsChangeRegion(true); setCurrentRegionId(region.id)}} viewBox="0 0 24 24" id="pen"><path fill="#6563FF" d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"></path></svg>
                            {confirmDeleteRegion === region.id ? <a className={styles.tablebtn} onClick={() => {handleDeleteClickRegion(region.id)}}>Подтвердить удаление</a> : <svg viewBox="0 0 24 24" id="trash-alt" onClick={() => {handleDeleteClickRegion(region.id)}}><path fill="#ff1818" d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"></path></svg>}
                        </span>
                    </div>
                    <div className={styles.tableContainer}>
                        <div className={styles.tableBody}>
                        {region.emails.length > 0 ? (
                            <>
                                {region.emails.map(email => (
                                    <>
                                    <div key={email.id} className={styles.tableLine}>
                                        <a style={{display: 'flex', flexDirection: 'column'}}>
                                            <span style={{display: 'flex', alignItems: 'center'}}>
                                            {email.userData ?
                                                (
                                                <container style={{cursor: 'pointer'}} onClick={() => {setIsCardOfAM(true); setCurrentAMId(email.userData.id)}}>
                                                    {email.email} 
                                                    <span style={{width: 'fit-content', marginTop: '5px'}}>{email.userData?.lastname} {email.userData?.firstname} {email.userData?.surname}</span>
                                                </container>
                                                )
                                                :
                                                (
                                                    <>{email.email}</>
                                                )
                                            }
                                                {email.userData &&
                                                ( email.userData.approval == 'Активен' ? (
                                                    <>
                                                        <img style={{margin: '0 15px', cursor: 'default'}} src='/img/icons/check-circle.svg' alt='-' />
                                                        <container style={{color: '#b8b8b8'}}>Арбитражный управляющий зарегистрирован в системе.</container>
                                                    </>
                                                    ) : email.userData.approval == 'Отключен' ? (
                                                    <>
                                                        <img style={{margin: '0 15px', cursor: 'default'}} src='/img/icons/ban.svg' alt='-' />
                                                        <container style={{color: '#b8b8b8'}}>Учётная запись арбитражного управляющего деактивирована.</container>
                                                    </>
                                                    ) :  email.userData.approval == 'На рассмотрении' ? (
                                                        <>
                                                            <img style={{margin: '0 15px', cursor: 'default'}} src='/img/icons/clock.svg' alt='-' />
                                                            <container style={{color: '#b8b8b8'}}>Арбитражный управляющий на стадии выдачи доступа к системе.</container>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <container style={{color: '#b8b8b8'}}>Ошибка системы.</container>
                                                        </>
                                                    )
                                                )}
                                            </span>
                                        </a>
                                        <span>
                                            {(!email.userData || email.userData.approval === 'Отключен') && <svg onClick={() => {setCurrentEmailId(email.id); setIsChangeEmailAM(true)}} viewBox="0 0 24 24" id="pen"><path fill="#6563FF" d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"></path></svg>}{!email.userData || email.userData.approval == 'Отключен' ? 
                                                (
                                                    confirmDeleteEmailAM === email.id ? <a onClick={() => {handleDeleteClickEmailAM(email.id)}}>Подтвердить удаление</a> : <svg viewBox="0 0 24 24" id="trash-alt" onClick={() => {handleDeleteClickEmailAM(email.id)}}><path fill="#ff1818" d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"></path></svg>
                                                )
                                                :
                                                (
                                                <>
                                                    <svg viewBox="0 0 24 24" id="trash-alt" onClick={() => {openModal('Предупреждение', warningModal)}}><path fill="#ff1818" d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"></path></svg>
                                                </>
                                                )
                                            }
                                        </span>
                                    </div>
                                    </>
                                ))}
                            </>
                        ) 
                        : 
                        (
                            <div className={styles.tableLine}>
                                <a>В системе отсутствуют e-mail адреса арбитражных управляющих из этого региона.</a>
                            </div>
                        )}
                            
                            <div className={styles.tableLine} style={{borderBottom: 'none'}}>
                                <button type='button' className={styles.button} style={{width: 'fit-content'}} onClick={() => {setCurrentRegionId(region.id); setIsAddNewEmailAM(true)}}>
                                    <svg viewBox="0 0 24 24" id="plus" fill="white"><path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path></svg>
                                    Добавить email
                                </button>
                            </div>
                        </div>
                    </div>
                </>
                ))}
            </>
            )} 
        </div>
    </>
    )
}

export default EmailsAM;
